import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import LogoBig from "../../assets/LogoBig";
import PoweredBy from "../PoweredBy";
import { useSelector, useDispatch } from "react-redux";
import { setNavigation } from "../../actions/navigation";
import Login from "../Login/LoginBox";
import Navigation from "./Navigation";
import { setCookie, vendorPath } from "../../helpers";
import { BrandButton, Hamburger } from "../../assets";
import Shop from "./Shop";
import Products from "./Products";
import ShopOrders from "./ShopOrders";
import MyOrders from "./MyOrders";
import "./style.scss";
import { getUserShop, getShopAddOns } from "../../actions/shop";
import AccountSummary from "./AccountSummary";
import Introductions from "./Introductions";
import AddOns from "./AddOns";
import { useDeviceSize, DESKTOP } from "../../assets/hooks/useDeviceSize";

export default function Account() {

	const dispatch = useDispatch();
	const { device } = useDeviceSize();
	const { user, shop } = useSelector(state => ({ user: state.session.user, shop: state.shop }));
	const open = useSelector(state => state.navigation.open);

	useEffect(() => {
		setCookie({
			key: "redirect_to",
			value: "/me"
		});
	}, []);

	useEffect(() => {
		if (user && user.shop) {
			dispatch(getUserShop());
			dispatch(getShopAddOns());
		}
	}, [dispatch, user]);



	return <div className="account">
		{device !== DESKTOP && open && <div className="overlay mobile-nav">
			<section>
				<h4>NAVIGATION</h4>
				<Navigation
					onLinkClick={link => dispatch(setNavigation(false))}
				/>
			</section>
		</div>}
		<header>
			<LogoBig
				fontColor="#000000"
				crossColor="#CE003B"
			/>
			{device !== DESKTOP && user && <div className="hamburger-wrapper" style={{ zIndex: 999 }}>
				<Hamburger
					value={open}
					onChange={val => dispatch(setNavigation(val))}
				/>
			</div>}
			{(user && shop && shop.id) && <div className="shop-link">
				<a href={vendorPath(shop.slug)} target="_blank" rel="noopener noreferrer" title="Go to your shop">
					<BrandButton className="brand-bg">{shop.name}</BrandButton>
				</a>
			</div>}
		</header>
		{user && <div className="view-splitter maximum-width flexy">
			{/* Holds the desktop navigation */}
			{device === DESKTOP && <div className="left">
				<section>
					<h4>NAVIGATION</h4>
				</section>
				<Navigation />
			</div>}
			<div className="right">
				{/* Authenticated routes */}
				<Switch>

					<Route path="/me" exact render={router => (
						<AccountSummary />
					)} />

					<Route path="/me/orders" exact render={router => (
						<MyOrders />
					)} />

					<Route path="/me/shop" exact render={router => (
						<Shop />
					)} />

					<Route path="/me/shop/products" exact render={router => (
						<Products />
					)} />

					<Route path="/me/shop/add-ons" exact render={router => (
						<AddOns />
					)} />

					<Route path="/me/shop/orders" exact render={router => (
						<ShopOrders />
					)} />

					<Route path="/me/introductions" exact render={router => (
						<Introductions />
					)} />

					<Route path="/" render={router => (
						<Redirect to="/me" />
					)} />

				</Switch>

			</div>

		</div>}

		{/* Anonymous routes */}
		{!user && <Switch>

			<Route path="/me/login" render={router => (
				<Login />
			)} />

			<Route path="/" render={router => (
				<Redirect to="/me/login" />
			)} />

		</Switch>}

		<PoweredBy branded={false} />
	</div>
}